import { Injectable } from "@angular/core";
import { HttpService } from "./http-service";
import { Configuracoes } from "../entities/configuracoes";
import { Usuario } from "../entities/usuario";
import * as CryptoJS from "crypto-js";
import { environment } from "src/enviroment";
import { isPlatformBrowser } from "@angular/common";
import { Inject, PLATFORM_ID } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { firstValueFrom, Observable } from "rxjs";
import { ConfiguracoesForm } from "../entities/configuracoesForms";
import { Router } from "@angular/router";
import { BehaviorSubject } from "rxjs";
import { UsuarioService } from "./usuario-service";
import { PedidoService } from "./pedido-service";
// import * as Sentry from "@sentry/angular";
declare var $: any;

type Banner = {
  id: number;
  link: string;
  image: string;
  imageMobile: string;
  ordem: number;
};

@Injectable({
  providedIn: "root",
})
export class InitProvider {
  public usuario: Usuario | any = { nivel: [] };
  public filiais: any = [];
  filiaisSubject = new BehaviorSubject<any[]>([]);
  filiais$ = this.filiaisSubject.asObservable();
  public banners: Banner[] | undefined;
  public inicializaPedido: boolean;
  public inicializaPedidoSubject = new BehaviorSubject<boolean>(false);
  public inicializaPedido$ = this.inicializaPedidoSubject.asObservable();
  public usaTipoPedido: boolean;
  public usaFilialEstoque: boolean;
  private loadedSubject = new BehaviorSubject<boolean>(false);
  public loaded$ = this.loadedSubject.asObservable();
  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    public http: HttpService,
    public http_: HttpClient,
    private router: Router,
    public usuarioService: UsuarioService,
    public pedidoService: PedidoService
  ) { }

  createHash(obj: string): string {
    const jsonString = JSON.stringify(obj);
    const key = CryptoJS.enc.Utf8.parse(environment.version);
    const iv = CryptoJS.lib.WordArray.random(16);
    const encrypted = CryptoJS.AES.encrypt(jsonString, key, {
      iv: iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    });
    const encryptedStr = CryptoJS.enc.Base64.stringify(
      iv.concat(encrypted.ciphertext)
    );
    return encryptedStr;
  }

  decryptData(encryptedData, secretKey) {
    try {
      const encryptedDataBytes = CryptoJS.enc.Base64.parse(encryptedData);
      const iv = CryptoJS.lib.WordArray.create(
        encryptedDataBytes.words.slice(0, 4),
        16
      );
      const encryptedMessage = CryptoJS.lib.WordArray.create(
        encryptedDataBytes.words.slice(4),
        encryptedDataBytes.sigBytes - 16
      );
      const key = CryptoJS.enc.Utf8.parse(secretKey);
      const decrypted = CryptoJS.AES.decrypt(
        { ciphertext: encryptedMessage },
        key,
        {
          iv: iv,
          mode: CryptoJS.mode.CBC,
          padding: CryptoJS.pad.Pkcs7,
        }
      );
      return decrypted.toString(CryptoJS.enc.Utf8);
    } catch (e) {
      console.error("Decryption failed:", e);
      return "";
    }
  }

  decryptAndShow(encrypted) {
    const secretKey = environment.version;
    const encryptedData = encrypted;

    if (encryptedData === "" || secretKey === "") {
      console.error("Encrypted data or secret key is empty.");
      return;
    }

    const decryptedData = this.decryptData(encryptedData, secretKey);
    return decryptedData;
  }
async load(): Promise<void> {
  try {
    /* =============================
     * CONFIG PRINCIPAL
     * ============================= */
    const resp: any = await firstValueFrom(
      this.http_.get("appconfig-v2.json", this.getHttpOptions())
    );

    const config = resp.prod
      ? JSON.parse(this.decryptAndShow(resp.dados))
      : resp;

    if (!config.API_BRANCH) {
      config.API_BRANCH = window.location.origin;
    }

    Configuracoes.patchAppConfig(config);

    /* =============================
     * CONFIG FORM
     * ============================= */
    const respForm: any = await firstValueFrom(
      this.http_.get("appconfig-forms.json", this.getHttpOptions())
    );

    ConfiguracoesForm.patchAppConfig(respForm);

    /* =============================
     * PRINCIPAL
     * ============================= */
    const principal: any = await new Promise((resolve, reject) => {
      this.http.get(
        "principal",
        (principalResponse: any) => {
          const parsed = Configuracoes.cypher
            ? JSON.parse(this.decryptAndShow(principalResponse.dados))
            : principalResponse;

          resolve(parsed);
        },
        reject
      );
    });

    /* =============================
     * CACHE / SW
     * ============================= */
    if (principal.configuracao.versao_cache !== resp.versao_cache) {
      if ("caches" in window) {
        const names = await caches.keys();
        await Promise.all(names.map((name) => caches.delete(name)));
      }

      if ("serviceWorker" in navigator) {
        const registrations =
          await navigator.serviceWorker.getRegistrations();
        await Promise.all(registrations.map((r) => r.unregister()));
      }

      console.log("Cache e Service Workers limpos!");
    } else {
      console.log("Cache e Service Workers mantidos!");
    }

    /* =============================
     * BANNERS
     * ============================= */
    if (Configuracoes.API_BANNERS) {
      this.http.get(
        Configuracoes.API_BANNERS.replace(Configuracoes.API, ""),
        (banners: Banner[]) => {
          principal.configuracao.sliderPrincipal = banners;
        }
      );
    }

    /* =============================
     * CONFIGURAÇÕES GLOBAIS
     * ============================= */
    Configuracoes.SITE = principal.configuracao;

    this.usaTipoPedido = principal.configuracao.usa_tipo_pagamento;
    this.usaFilialEstoque = principal.configuracao.usa_filial_estoque;

    /* =============================
     * USUÁRIO LOGADO
     * ============================= */
    if (this.hasToken()) {
      try {
        this.usuario = await new Promise((resolve, reject) => {
          this.http.get("usuario", resolve, reject);
        });

        this.inicializaPedido = this.usuario.inicia_pedido_selecionado;
        this.inicializaPedidoSubject.next(this.inicializaPedido);

        if (Configuracoes.SITE.appendHeadAfterLogin) {
          $("body").append(Configuracoes.SITE.appendHeadAfterLogin);
        }

        /* =============================
         * CLIENTES DO USUÁRIO
         * ============================= */
        await new Promise<void>((resolve) => {
          this.usuarioService.getClientes(
            { busca: "" },
            async (clientesUsuario) => {
              if (
                Array.isArray(clientesUsuario) &&
                clientesUsuario.length === 1
              ) {
                const clienteResp: any = await new Promise(
                  (resolveCliente) => {
                    this.usuarioService.getClientesId(
                      { id_cliente: clientesUsuario[0].id },
                      (resp) => resolveCliente(resp)
                    );
                  }
                );

                this.filiais = Array.isArray(clienteResp?.filiais)
                  ? clienteResp.filiais
                  : [];
              } else {
                this.filiais = [];
              }

              this.filiaisSubject.next(this.filiais);

              resolve();
            }
          );
        });

        /* =============================
         * PEDIDO ATIVO V2
         * ============================= */
        try {
          const pedidoAtivo: any = await firstValueFrom(
            this.http_.get(
              `${Configuracoes.API}v2/pedido/ativo`,
              this.getHttpOptions()
            )
          );

          console.log("Pedido ativo:", pedidoAtivo);

          if (pedidoAtivo) {
             this.pedidoService.getPedidoId(pedidoAtivo.pedido_ativo, (e) => {
              this.pedidoService.select(e);
            });
            // localStorage.setItem("pedido", JSON.stringify(pedidoAtivo));
          }
        } catch (error) {
          console.warn("Nenhum pedido ativo encontrado.", error);
          localStorage.removeItem("pedido");
        }
      } catch (error) {
        if (isPlatformBrowser(this.platformId)) {
          localStorage.removeItem("token");
          localStorage.removeItem("tipoUsuario");
          localStorage.removeItem("pedido");

          await this.router.navigate(["/login"]);
          window.location.reload();
        }
      }
    }

    this.loadedSubject.next(true);
  } catch (error) {
    console.error("Erro durante o carregamento da aplicação:", error);
  }
}

  hasToken() {
    if (isPlatformBrowser(this.platformId)) {
      return window.localStorage.getItem("token") != null;
    }
  }

  getToken() {
    if (isPlatformBrowser(this.platformId)) {
      return window.localStorage.getItem("token");
    }
  }

  // async getLocation() {
  //   await new Promise((resolve, reject) => {
  //     this.http
  //       .get(
  //         "https://geolocation.onetrust.com/cookieconsentpub/v1/geo/location",
  //         this.getHttpOptions()
  //       )
  //       .subscribe(
  //         (resp) => {
  //           resolve(true);
  //         },
  //         (error) => {
  //           console.log("erro", error);
  //           resolve(false);
  //         }
  //       );
  //   });
  // }

  getHttpOptionsLogin() {
    const now = Date.now();
    let headers = new HttpHeaders({
      "Content-Type": "application/json",
      // Para utilizar a hash com data/hora, descomente a linha abaixo e implemente a função createHash se necessário:
      // 'Branch': this.createHash(Configuracoes.API_BRANCH + " " + now),
      Branch: Configuracoes.API_BRANCH,
    });

    if (this.hasToken()) {
      headers = headers.set("Authorization", "Bearer " + this.getToken());
    }

    return { headers };
  }

  getHttpOptions() {
    const now = Date.now();
    let headers = new HttpHeaders({
      "Content-Type": "application/json",
      // Para utilizar a hash com data/hora, descomente a linha abaixo e implemente a função createHash se necessário:
      // "Branch": this.createHash(Configuracoes.API_BRANCH + " " + now),
      Branch: Configuracoes.API_BRANCH,
    });

    if (this.hasToken()) {
      headers = headers.set("Authorization", "Bearer " + this.getToken());
    }

    return { headers };
  }
}
